import React from 'react';
import {
  arrayOf,
  shape,
  string,
  func,
  bool,
} from 'prop-types';
import { Block, Button, Link } from 'components/common';
import { withTracking } from 'components/tracking';
import './GlossaryPanel.scss';

const GlossaryPanel = ({
  glossaryCta = {},
  heading,
  subheading,
  viewAllCta = {},
  track,
  isEnableTracking,
}) => (
  <div className="glossary-panel" data-selector-type="glossary-panel">
    <Block>
      <Block.Header
        title={heading}
        subtitle={subheading}
      />
      <div className="glossaries">
        {glossaryCta && glossaryCta.links && glossaryCta.links.map(({ title, href }, idx) => (
          <div
            className="glossary"
            key={title + href}
          >
            <a
              href={href}
              rel="noopener noreferrer"
              target="_blank"
              data-selector-type="glossary"
              data-selector-index={idx}
              onClick={() => isEnableTracking && track({
                data: {
                  event: 'navigate',
                  componentType: 'glossary',
                  action: 'click',
                  title,
                },
              })}
            >
              <Button text>
                {title}
              </Button>
            </a>
          </div>
        ))}
      </div>
      <div>
        <Link
          to={viewAllCta.href}
          onClick={() => isEnableTracking && track({
            data: {
              event: 'navigate',
              componentType: 'glossary',
              action: 'click',
              title: viewAllCta && viewAllCta.title,
            },
          })}
        >
          <Button
            styleName="ghost"
            rightIconName="chevron_forward"
          >
            {viewAllCta && viewAllCta.title}
          </Button>
        </Link>
      </div>
    </Block>
  </div>
);

GlossaryPanel.defaultProps = {
  glossaryCta: {},
  heading: '',
  subheading: '',
  viewAllCta: {},
  isEnableTracking: false,
};

GlossaryPanel.propTypes = {
  glossaryCta: shape({
    links: arrayOf(
      shape({
        title: string,
        href: string,
      })
    ),
  }),
  heading: string,
  subheading: string,
  viewAllCta: shape({
    title: string,
    href: string,
  }),
  track: func.isRequired,
  isEnableTracking: bool,
};

export default withTracking(GlossaryPanel);
